// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__kNaY1","description":"PatientConsentPreview_description__3jKDf"};